import { useSelector } from 'react-redux';
import { player } from 'src/client/player';
import { PLAYER_MANAGER_ENABLED } from 'src/common/constants/experiments/config';
import useExperiment from 'src/common/hooks/useExperiment';
import { useStores } from 'src/common/providers';
import { setVolume } from '../actions/player';
import { selectIsDiscord, selectIsFord, selectIsMobile } from '../selectors/app';
import { selectPlayerVolume } from '../selectors/player';
import { getVolume as getVolumeFromStorage } from '../utils/storage/playerVolume';
import useActions from './useActions';
import useOnMount from './useOnMount';

const DEFAULT_VOLUME_FOR_DISCORD = 20;
const DEFAULT_MOBILE_VOLUME_FOR_DISCORD = 50;

export function useSetPlayerVolume() {
  const isPlayerManagerEnabled = useExperiment(PLAYER_MANAGER_ENABLED);
  const { playerStore } = useStores();
  const playerManagerVolume = playerStore.volume();
  const actions = useActions({
    setVolume,
  });
  const volume = useSelector(selectPlayerVolume);
  const isDiscord = useSelector(selectIsDiscord);
  const isMobile = useSelector(selectIsMobile);
  const isFord = useSelector(selectIsFord);

  useOnMount(() => {
    const volumeFromStorage = getVolumeFromStorage();
    let volumeToSet;

    if (Number.isFinite(volumeFromStorage)) {
      volumeToSet = volumeFromStorage;
    } else if (isDiscord && isMobile && !isFord) {
      volumeToSet = DEFAULT_MOBILE_VOLUME_FOR_DISCORD;
    } else if (isDiscord && !isFord) {
      volumeToSet = DEFAULT_VOLUME_FOR_DISCORD;
    } else {
      volumeToSet = isPlayerManagerEnabled ? playerManagerVolume * 100 : volume;
    }

    player.isActive ? player.setVolume(volumeToSet) : actions.setVolume(volumeToSet);
  });
}
